<template>
  <div class="person-search-pdf">
    <h4 style="font-family: PT Sans;">{{ $t('message.find_person.types.' + responseType) }}</h4>
    <div v-if="isLoading" class="w-100 h-100 d-flex justify-content-center align-items-center">
      <div class="loader"></div>
    </div>
    <div v-else-if="typeof response === 'object' && !isLoading" class="row"
      :style="pdfProps.width ? { width: pdfProps.width + 'px' } : {}">
      <AnyJsonRenderer
        :data="response"
        :isRenderEmpty="true"
        :vocabulary="this.$t('message.find_person.vocabulary')"
        :imLoaded="pdfProps ? pdfProps.childFullyLoaded : undefined"
        />
        <!-- TODO(justas) -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    pdfProps: {
      type: Object,
      required: false,
      default: () => ({}),
      // {
      //     width: Number               // Page content width without margins
      //     height: Number              // Page content height without margins (page will be auto added if content is bigger)
      //     childFullyLoaded: Function  // Call me on fully load
      // }
    },
    response: {
      type: Object,
      required: true,
    },
    responseType: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    timeAgo(timestamp) {
      return moment(timestamp).locale(this.$i18n.locale).fromNow();
    },
    timeDate(timestamp) {
      return moment(timestamp).locale(this.$i18n.locale).format("LL");
    },
  },
  computed: {},
  watch: {},
};
</script>
<style>
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>